import React, { useEffect } from 'react';
import { useNetworkSettings } from 'hooks/useNetworkSettings';

const NetworkSettingsProvider = ({ children }) => {
  const { networkSettings, loading } = useNetworkSettings();

  useEffect(() => {
    if (!loading && networkSettings) {
      // Update CSS custom properties
      const root = document.documentElement;

      root.style.setProperty(
        '--navbar-color-light-mode',
        networkSettings.navbar_color_light_mode || '#444444',
      );
      root.style.setProperty(
        '--navbar-color-dark-mode',
        networkSettings.navbar_color_dark_mode || '#000000',
      );
      root.style.setProperty(
        '--sidebar-background',
        networkSettings.navbar_color_dark_mode || '#001529',
      );
      root.style.setProperty(
        '--header-background',
        networkSettings.navbar_color_light_mode || '#fff',
      );
    }
  }, [networkSettings, loading]);

  return <>{children}</>;
};

export default NetworkSettingsProvider;
